/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Payload to update document parse status.
 * @export
 * @interface UpdateParseStatusRequest
 */
export interface UpdateParseStatusRequest {
    /**
     * New parsing status
     * @type {string}
     * @memberof UpdateParseStatusRequest
     */
    status: UpdateParseStatusRequestStatusEnum;
    /**
     * Error message if status is failed
     * @type {string}
     * @memberof UpdateParseStatusRequest
     */
    error?: string;
}


/**
 * @export
 */
export const UpdateParseStatusRequestStatusEnum = {
    Pending: 'pending',
    Parsed: 'parsed',
    Failed: 'failed'
} as const;
export type UpdateParseStatusRequestStatusEnum = typeof UpdateParseStatusRequestStatusEnum[keyof typeof UpdateParseStatusRequestStatusEnum];


/**
 * Check if a given object implements the UpdateParseStatusRequest interface.
 */
export function instanceOfUpdateParseStatusRequest(value: object): value is UpdateParseStatusRequest {
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function UpdateParseStatusRequestFromJSON(json: any): UpdateParseStatusRequest {
    return UpdateParseStatusRequestFromJSONTyped(json, false);
}

export function UpdateParseStatusRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateParseStatusRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function UpdateParseStatusRequestToJSON(json: any): UpdateParseStatusRequest {
    return UpdateParseStatusRequestToJSONTyped(json, false);
}

export function UpdateParseStatusRequestToJSONTyped(value?: UpdateParseStatusRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
        'error': value['error'],
    };
}

